import { Check, RotateCcw } from "lucide-react";
import { cn } from "@/lib/utils";

/** How far through a list the reader is. Shown on the list itself, where the decision is made. */
export const ShoppingProgress = ({ bought, total, onClear, testId }) => {
  const percent = total ? Math.round((bought / total) * 100) : 0;
  return (
    <div data-testid={testId} className="space-y-2.5">
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
        <p className="text-[13px] font-bold text-brand-teal">
          <span data-testid={`${testId}-count`}>
            {bought} of {total}
          </span>{" "}
          <span className="font-semibold text-brand-teal/55">bought</span>
        </p>
        {!!bought && (
          <button
            data-testid={`${testId}-clear`}
            onClick={onClear}
            className="ps-tap inline-flex min-h-[36px] items-center gap-1.5 rounded-full bg-brand-teal/[0.06] px-3.5 text-[12px] font-bold text-brand-tealSoft transition-colors hover:bg-brand-teal/[0.12] hover:text-brand-orangeInk"
          >
            <RotateCcw className="h-3.5 w-3.5" /> Clear list
          </button>
        )}
      </div>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-brand-teal/[0.08]">
        <div
          className="h-full rounded-full bg-brand-green transition-[width] duration-500"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
};

/** The tick itself. Big enough for a thumb in a busy market, quiet enough to read past. */
export const ShoppingCheck = ({ checked, onChange, label }) => (
  <button
    role="checkbox"
    aria-checked={checked}
    aria-label={`${checked ? "Bought" : "Not bought"}: ${label}`}
    onClick={onChange}
    className={cn(
      "ps-tap grid h-[26px] w-[26px] shrink-0 place-items-center rounded-[9px] border-2 transition-all duration-150",
      checked
        ? "border-brand-green bg-brand-green text-white"
        : "border-brand-teal/25 bg-white text-transparent hover:border-brand-green/70"
    )}
  >
    <Check className="h-[15px] w-[15px]" strokeWidth={3} />
  </button>
);
